const reIOS = new RegExp("iPhone|iPad|iPod");
const reMac = new RegExp("Mac");
export const isIOS = () => {
  return reIOS.test(navigator.platform || "") || reIOS.test(navigator.userAgent || "") || (reMac.test(navigator.platform || "") || reMac.test(navigator.userAgent || "")) && navigator.maxTouchPoints > 1;
};
export default isIOS;